module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Simone_CR-p-800-f40228e6c76fd458e9ece39ebec6d3cb.jpg";